import store from "../store";

export const AppDispatch = (action) => store.dispatch(action);